<template>
    <div class="page_banner">
        <div class="group_204 flex-col">
            <div class="group_7 flex-col">
                <!-- 轮播容器 -->
                <div class="box_4 flex-col" @mouseenter="pauseAutoPlay" @mouseleave="resumeAutoPlay">
                    <!-- 轮播图片 -->
                    <div
                            v-for="(img, index) in banners"
                            :key="index"
                            class="banner-item"
                            :class="{ active: currentIndex === index }"
                            :style="{ backgroundImage: `url(${img})` }"
                    ></div>

                    <!-- 内容区域 -->
                    <div class="content-container">
                        <div class="box_195 flex-row justify-between">
                            <!-- 原有文本内容 -->
                            <div class="text-group_406 flex-col">
                                <span class="text_8">愿景和使命</span>
                                <span class="text_9">致力成为全球化商业组织的健康管理专家</span>
                                <span class="text_10">助力企业实现可持续发展</span>
                            </div>
                        </div>
                        <div class="box_196 flex-row">
                            <div class="text-wrapper_2 flex-col"
                                 @click="goto('contact')"
                            ><span class="text_11">联系我们</span></div>
                        </div>
                    </div>

                    <!-- 指示器 -->
                    <div class="indicators">
                        <div
                                v-for="(item, index) in banners"
                                :key="index"
                                class="indicator"
                                :class="{ active: currentIndex === index }"
                                @click="switchBanner(index)"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            banners: {
                type: Array,
                default: () => [
                    require('../../../assets/tempImg/banner01.png'),
                ]
            }
        },
        data() {
            return {
                currentIndex: 0,
                timer: null,
            };
        },
        mounted() {
            this.startAutoPlay();
        },
        beforeUnmount() {
            this.clearAutoPlay();
        },
        methods: {
            goto(url){
                url = '/' + url;
                this.$router.push(url);
            },
            startAutoPlay() {
                this.timer = setInterval(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.banners.length;
                }, 5000);
            },
            pauseAutoPlay() {
                this.clearAutoPlay();
            },
            resumeAutoPlay() {
                this.startAutoPlay();
            },
            clearAutoPlay() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            switchBanner(index) {
                this.currentIndex = index;
            }
        }
    };
</script>

<style scoped lang="css"  >

    /* 新增轮播相关样式 */
    .box_4 {
        position: relative;
        overflow: hidden;
        height: 582px;
        width: 100%;
    }

    .banner-item {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        transition: opacity 1s ease-in-out;
        background-size: cover;
        background-position: center;

        background-repeat: no-repeat;
    }

    .banner-item.active {
        opacity: 1;
    }

    .content-container {
        position: relative;
        z-index: 2; /* 保证内容在轮播图之上 */
    }

    /* 指示器样式圆形 */
    .indicators_yuan {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 10px;
        z-index: 3;
    }

    .indicator_yuan {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255,255,255,0.5);
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .indicator_yuan.active {
        background: rgba(255,255,255,1);
        transform: scale(1.2);
    }
    /* 指示器样式 */
    .indicators {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        gap: 6px;
        z-index: 3;
    }

    .indicator {
        width: 30px;
        height: 4px;
        background: rgba(255,255,255,0.3);
        border-radius: 2px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .indicator.active {
        width: 43px;
        background: #FFFFFF;
        border-radius: 2px;
    }
    /***/

    .group_204 {
        width: 100%;
        height: 582px;
    }

    .group_7 {
        height: 582px;
        width: 100%;
    }



    .box_195 {
        width: 903px;
        height: 176px;
        margin: 155px 0 0 134px;
    }

    .text-group_406 {
        width: 496px;
        height: 176px;
    }

    .text_8 {
        width: 217px;
        height: 70px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 44px;
        font-family: AlibabaPuHuiTi_3_85_Bold;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 70px;
    }

    .text_9 {
        width: 496px;
        height: 44px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 44px;
        margin-top: 17px;
    }

    .text_10 {
        width: 304px;
        height: 44px;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 44px;
        margin-top: 1px;
    }

    .box_196 {
        width: 182px;
        height: 45px;
        margin: 42px 0 0 134px;
    }

    .text-wrapper_2 {
        height: 45px;
        background: url(../../../assets/home/home_contact_me.png)
        100% no-repeat;
        background-size: 100% 100%;
        width: 182px;

        cursor: pointer;
        transition: all 0.3s ease; /* 添加过渡动画 */
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    /* 悬停状态 */
    .text-wrapper_2:hover {
        transform: translateY(-2px); /* 轻微上移效果 */
    }

    /* 点击状态 */
    .text-wrapper_2:active {
        transform: translateY(1px);
        filter: brightness(0.9); /* 点击时变暗 */
    }

    .text_11 {
        width: 74px;
        height: 34px;
        overflow-wrap: break-word;
        color: rgba(31, 128, 115, 1);
        font-size: 18px;
        letter-spacing: 0.6000000238418579px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: NaN;
        text-align: left;
        white-space: nowrap;
        line-height: 34px;
        margin: 6px 0 0 58px;
    }


</style>
